// extracted by mini-css-extract-plugin
module.exports = {"page":"ConsentsPage_page__2e4n5","title":"ConsentsPage_title__3lhAd"};